const buyContractAddress = "0xd2c419A28d2a6E26c8a94BF620D70A5C013Ce68F"// ETH mainnet market


export default buyContractAddress